module.exports = __webpack_public_path__ + "static/media/mobile.6f449543.jpg";